import React, { useEffect } from 'react';
import { FormProvider, useFieldArray, useForm } from 'react-hook-form';
import { confirmDialog } from 'primereact/confirmdialog';

import { RenderContent } from '../FormBuilder/components/FormComponenets/RenderContent';
import { FormHeader } from './FormHeader';
import { FormFooter } from './FormFooter';
import A4Page from '../FormBuilder/components/FormComponenets/A4Page';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';
import ReCapcha from '../FormBuilder/components/pageElements/ReCapcha';
import PoweredBy from '../FormBuilder/components/FormComponenets/PoweredBy';
import useLeadIntakeForm from '../hooks/useLeadIntakeForm';
import SkeletonLoader from './SkeletonLoader';
import useGetListAPI from '../hooks/useGetListAPI';

const FormField = ({ item, index }) => (
  <>
    {RenderContent({
      className: 'py-2 w-100',
      condition: item.type,
      props: { index, item, handleSettingsClick: () => null, isFormBuilder: false },
    })}
  </>
);

export default function LeadIntakePreview() {
  const methods = useForm({ defaultValues: { form_data: [] } });
  const { fields } = useFieldArray({ control: methods.control, name: 'form_data' });
  const { loading, formData, isSubmitted, saveLeadIntake, logError } = useLeadIntakeForm();
  const { getGeneralListService } = useGetListAPI();

  const title = methods.watch('form_name');
  const description = methods.watch('form_description');

  useEffect(() => {
    getGeneralListService('practice_area');
  }, []);

  useEffect(() => {
    if (formData) {
      methods.reset(formData);
    }
  }, [formData]);

  // const resubmit = () => {
  //   // setIsSubmitted(false);
  //   methods.clearErrors();
  //   methods.reset(formData);
  // };

  const handleSubmit = methods.handleSubmit(
    (data) => {
      confirmDialog({
        message: 'Are you sure you want to submit the form?',
        header: 'Confirmation',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        accept: () => saveLeadIntake(data),
      });
    },
    (errors) => {
      // logError(errors, methods.getValues());
    }
  );

  return (
    <FormProvider {...methods}>
      <GlobalLoader />
      <div className="preview-form">
        <A4Page>
          {loading ? (
            <SkeletonLoader />
          ) : (
            <>
              {formData && !isSubmitted ? (
                <>
                  <FormHeader title={title} description={description} />
                  {fields?.map((item, index) => (
                    <FormField key={item.id} item={item} index={index} />
                  ))}
                  <ReCapcha />
                  <FormFooter onSubmit={handleSubmit} />
                </>
              ) : isSubmitted === true ? (
                <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
                  <h3 style={{ fontWeight: 'bold' }}>Thank You</h3>
                  Submitted Successfully
                  {/* <div>
                    <Button className="buton p-button-secondary mt-3" onClick={resubmit}>Submit Again</Button>
                  </div> */}
                </div>
              ) : (
                <div>Invalid Link! Please contact your firm.</div>
              )}
            </>
          )}
        </A4Page>
        <PoweredBy />
      </div>
    </FormProvider>
  );
}
